import http from "../http-common";
class SecretaireDataService {
  secmed(email) {
    return http.get(`/secretaire/secmed?email=${email}`);
  }
  secmedrdv(email,med) {
    return http.get(`/secretaire/secmedrdv?email=${email}&med=${med}`);
  }
  secmedrdv2(email) {
    return http.get(`/secretaire/secmedrdv2?email=${email}`);
  }
  effetRdv(email,idrdv) {
    return http.put(`/secretaire/rdveffet?email=${email}&idrdv=${idrdv}`);
  }
  cancelEffetRdv(email,idrdv) {
    return http.put(`/secretaire/cancelrdveffet?email=${email}&idrdv=${idrdv}`);
  }
}
export default new SecretaireDataService();